module.exports = __webpack_public_path__ + "assets/img/1.ff70edf8.png";